"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connect = exports.wsUrlParseFn = void 0;
/*
 * Copyright 2020-2023 The NATS Authors
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const internal_mod_1 = require("../nats-base-client/internal_mod");
const ws_transport_1 = require("./ws_transport");
function wsUrlParseFn(u) {
    const ut = /^(.*:\/\/)(.*)/;
    if (!ut.test(u)) {
        u = `https://${u}`;
    }
    let url = new URL(u);
    const srcProto = url.protocol.toLowerCase();
    if (srcProto !== "https:" && srcProto !== "http") {
        u = u.replace(/^(.*:\/\/)(.*)/gm, "$2");
        url = new URL(`http://${u}`);
    }
    let protocol;
    let port;
    const host = url.hostname;
    const path = url.pathname;
    const search = url.search || "";
    switch (srcProto) {
        case "http:":
        case "ws:":
        case "nats:":
            port = url.port || "80";
            protocol = "ws:";
            break;
        default:
            port = url.port || "443";
            protocol = "wss:";
            break;
    }
    return `${protocol}//${host}:${port}${path}${search}`;
}
exports.wsUrlParseFn = wsUrlParseFn;
function connect(opts = {}) {
    (0, internal_mod_1.setTransportFactory)({
        defaultPort: 443,
        urlParseFn: wsUrlParseFn,
        factory: () => {
            return new ws_transport_1.WsTransport();
        },
    });
    return internal_mod_1.NatsConnectionImpl.connect(opts);
}
exports.connect = connect;
//# sourceMappingURL=connect.js.map